function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import Icon from '../Icon.js';
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edit_svg__a)",
    stroke: "var(--icon-color)",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.952 14.048-5.1 1.12 1.12-5.102L10.87 1.13a1.182 1.182 0 0 1 1.661.112l1.108 1.107 1.108 1.107a1.182 1.182 0 0 1 .11 1.664l-8.905 8.928Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 3 4 4"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edit_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};
var IconEdit = function IconEdit(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    icon: SvgEdit
  }, props));
};
export default IconEdit;